<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Enterprises"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.email"
                  label="E-mail"
                  prepend-inner-icon="fas fa-envelope"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="password"
                :rules="add"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.password"
                  label="Password"
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'fas fa-eye' : 'fas fa-eye-slash'"
                  @click:append="show1 = !show1"
                  autocomplete="off"
                  readonly
                  :rules="[required, min6]"
                  :counter="6"
                  onfocus="this.removeAttribute('readonly');"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="company_id"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :error-messages="errors"
                  v-model="data.company_id"
                  label="Company"
                  :items="companies"
                  item-value="id"
                  item-text="name"
                >
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  data() {
    return {
      storeName: "Enterprises",
      title: "Enterprise",
      filteredAttributes: ["profile_picture"],
      show1: false,
      add: "required",
      data: {
        user_role: "admin_enterprise",
        email: "",
        password: undefined,
        company_id: ""
      }
    };
  },
  created() {
    const self = this;
    if (this.$route.params.id) {
      this.add = "";
      this.$store
        .dispatch(`${this.storeName}/show`, this.$route.params.id)
        .then(function(data) {
          for (let i in data) {
            if (
              self.data[i] !== undefined &&
              !self.filteredAttributes.includes(i)
            ) {
              self.data[i] = data[i];
            } else {
              if (
                self.filteredAttributes.includes(i) &&
                self[i] !== undefined
              ) {
                self[i] = data[i];
              }
            }
          }
        });
    }
    this.$store.dispatch(`Companies/getListAll`, { show_all: "enable" });
  },
  computed: {
    ...mapState({
      status: state => state.Enterprises.status,
      companies: state => state.Companies.list
    })
  },
  methods: {
    required: function(value) {
      if (this.add == "") {
        return true;
      }
      if (value) {
        return true;
      } else {
        return "This field is required.";
      }
    },
    min6: function(value) {
      if (this.add == "") {
        return true;
      }
      if (value && value.length >= 6) {
        return true;
      } else {
        return "Password should have more than 6 characters.";
      }
    }
  }
};
</script>
